import {} from 'react-redux';

import { Action } from '@reduxjs/toolkit';

import * as actionTypes from '../constants/global-telecom';

import { updateObject } from '../../../../shared/utils/utility';

import { AppAction } from '../../../../store';

import { GlobalTelecomAccount } from '../../models';

export interface GlobalTelecomState {
  globalTelecomAccount: GlobalTelecomAccount | null;
  globalTelecomAccountError: any | null;
  globalTelecomAccountLoading: boolean;

  saveGlobalTelecomAccount: boolean | null;
  saveGlobalTelecomAccountError: any | null;
  saveGlobalTelecomAccountLoading: boolean;

  deleteGlobalTelecomAccountResult: boolean | null;
  deleteGlobalTelecomAccountError: any | null;
  deleteGlobalTelecomAccountLoading: boolean;
}

const initialState: GlobalTelecomState = {
  globalTelecomAccount: null,
  globalTelecomAccountError: null,
  globalTelecomAccountLoading: false,

  saveGlobalTelecomAccount: null,
  saveGlobalTelecomAccountError: null,
  saveGlobalTelecomAccountLoading: false,

  deleteGlobalTelecomAccountResult: null,
  deleteGlobalTelecomAccountError: null,
  deleteGlobalTelecomAccountLoading: false,
};

const getGlobalTelecomAccountStart = (state: GlobalTelecomState, action: AppAction<GlobalTelecomAccount>) => {
  return updateObject(state, {
    globalTelecomAccountError: null,
    globalTelecomAccountLoading: true,
  });
};

const getGlobalTelecomAccountSuccess = (state: GlobalTelecomState, action: AppAction<GlobalTelecomAccount>) => {
  return updateObject(state, {
    globalTelecomAccount: action.data,
    globalTelecomAccountError: null,
    globalTelecomAccountLoading: false,
  });
};

const getGlobalTelecomAccountFail = (state: GlobalTelecomState, action: AppAction<GlobalTelecomAccount>) => {
  return updateObject(state, {
    globalTelecomAccount: null,
    globalTelecomAccountError: action.error,
    globalTelecomAccountLoading: false,
  });
};

const saveGlobalTelecomAccountStart = (state: GlobalTelecomState, action: AppAction<boolean>) => {
  return updateObject(state, {
    saveGlobalTelecomAccountError: null,
    saveGlobalTelecomAccountLoading: true,
  });
};

const saveGlobalTelecomAccountSuccess = (state: GlobalTelecomState, action: AppAction<boolean>) => {
  return updateObject(state, {
    saveGlobalTelecomAccount: action.data,
    saveGlobalTelecomAccountError: null,
    saveGlobalTelecomAccountLoading: false,
  });
};

const saveGlobalTelecomAccountFail = (state: GlobalTelecomState, action: AppAction<boolean>) => {
  return updateObject(state, {
    saveGlobalTelecomAccount: null,
    saveGlobalTelecomAccountError: action.error,
    saveGlobalTelecomAccountLoading: false,
  });
};

const deleteGlobalTelecomAccountStart = (state: GlobalTelecomState, action: AppAction<boolean>) => {
  return updateObject(state, {
    deleteGlobalTelecomAccountError: null,
    deleteGlobalTelecomAccountLoading: true,
  });
};

const deleteGlobalTelecomAccountSuccess = (state: GlobalTelecomState, action: AppAction<boolean>) => {
  return updateObject(state, {
    globalTelecomAccount: null,
    deleteGlobalTelecomAccountResult: action.data,
    deleteGlobalTelecomAccountError: null,
    deleteGlobalTelecomAccountLoading: false,
  });
};

const deleteGlobalTelecomAccountFail = (state: GlobalTelecomState, action: AppAction<boolean>) => {
  return updateObject(state, {
    deleteGlobalTelecomAccountResult: null,
    deleteGlobalTelecomAccountError: action.error,
    deleteGlobalTelecomAccountLoading: false,
  });
};

const reducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case actionTypes.GLOBAL_TELECOM_GET_GLOBAL_TELECOM_ACCOUNT_START:
      return getGlobalTelecomAccountStart(state, action as AppAction<GlobalTelecomAccount>);
    case actionTypes.GLOBAL_TELECOM_GET_GLOBAL_TELECOM_ACCOUNT_SUCCESS:
      return getGlobalTelecomAccountSuccess(state, action as AppAction<GlobalTelecomAccount>);
    case actionTypes.GLOBAL_TELECOM_GET_GLOBAL_TELECOM_ACCOUNT_FAIL:
      return getGlobalTelecomAccountFail(state, action as AppAction<GlobalTelecomAccount>);

    case actionTypes.GLOBAL_TELECOM_SAVE_GLOBAL_TELECOM_ACCOUNT_START:
      return saveGlobalTelecomAccountStart(state, action as AppAction<boolean>);
    case actionTypes.GLOBAL_TELECOM_SAVE_GLOBAL_TELECOM_ACCOUNT_SUCCESS:
      return saveGlobalTelecomAccountSuccess(state, action as AppAction<boolean>);
    case actionTypes.GLOBAL_TELECOM_SAVE_GLOBAL_TELECOM_ACCOUNT_FAIL:
      return saveGlobalTelecomAccountFail(state, action as AppAction<boolean>);

    case actionTypes.GLOBAL_TELECOM_DELETE_GLOBAL_TELECOM_ACCOUNT_START:
      return deleteGlobalTelecomAccountStart(state, action as AppAction<boolean>);
    case actionTypes.GLOBAL_TELECOM_DELETE_GLOBAL_TELECOM_ACCOUNT_SUCCESS:
      return deleteGlobalTelecomAccountSuccess(state, action as AppAction<boolean>);
    case actionTypes.GLOBAL_TELECOM_DELETE_GLOBAL_TELECOM_ACCOUNT_FAIL:
      return deleteGlobalTelecomAccountFail(state, action as AppAction<boolean>);

    default:
      return state;
  }
};

export default reducer;
